export const audiosRoute = 'library/audios';
export const audioByIdRoute = (UUID: string) => `library/audios/${UUID}`;
export const addAudioRoute = 'library/audios';
export const patchAudioRoute = (UUID: string) => `library/audios/${UUID}`;
export const deleteAudioRoute = (UUID: string) => `library/audios/${UUID}`;
